// extracted by mini-css-extract-plugin
module.exports = {"btn":"MarkAsSpam__btn__1cDed","tooltip":"MarkAsSpam__tooltip__nzrtM","icon":"MarkAsSpam__icon__3IECe","icon--active":"MarkAsSpam__icon--active__1zhRq"};